module.exports = __webpack_public_path__ + "static/cai_inventory_transparent-dcca373cef8d4c6183a46a3d39fcf5c6.png";